<template>
  <div class="card">
    <div class="card-header">
      {{header}}
    </div>
    <ul class="list-group list-group-flush">
      <li class="list-group-item" v-for="item in items" :key="item.key">
        <slot :name="item.key" :data="item">
          <span v-if="item.label">
            {{item.label}} : <strong :title="item.title || ''">{{item.value}}</strong>
          </span>
          <span v-else>
            <strong v-if="item.html" :title="item.title || ''" v-html="item.value"></strong>
            <strong v-else :title="item.title || ''">{{item.value}}</strong>
          </span>
        </slot>
      </li>
    </ul>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  props: {
    header: String,
    items: Array,
  }
}
</script>




// WEBPACK FOOTER //
// src/components/CardListInfo.vue